module.exports = __webpack_public_path__ + "static/img/18.21e339c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/18.png
// module id = +Sd9
// module chunks = 0